import { render, staticRenderFns } from "./SetupKebijakanWilayahHarga.vue?vue&type=template&id=6a910430&"
import script from "./SetupKebijakanWilayahHarga.vue?vue&type=script&lang=js&"
export * from "./SetupKebijakanWilayahHarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports